export const BIKE_LOADING = "BIKE_LOADING";
export const BIKE_ERROR = "BIKE_ERROR";
export const BIKE_GET_STATUSES = "BIKE_GET_STATUSES";
export const BIKE_LIST = "BIKE_LIST";
export const BIKE_LIST_NO_PAGINATION = "BIKE_LIST_NO_PAGINATION";
export const BIKE_GET_SINGLE = "BIKE_GET_SINGLE";
export const BIKE_FILTERS = "BIKE_FILTERS";
export const BIKE_UPDATE_STATUS = "BIKE_UPDATE_STATUS";
export const BIKE_UPDATE = "BIKE_UPDATE";
export const BIKE_GET_ALERTS = "BIKE_GET_ALERTS";
export const BIKE_SET_ALERT = "BIKE_SET_ALERT";
export const BIKE_GET_ALERT_TYPES = "BIKE_GET_ALERT_TYPES";



// WEBPACK FOOTER //
// ./src/actions/bike/constants.js